import React from 'react'
import type { BetSlipItem } from '@mobi/betslip/types'
import { isFatalErrorType } from '@mobi/betslip/helpers/state'
import { isToteSelection } from '@mobi/betslip/helpers/typeGuards'
import { FobInvestment, ToteInvestment } from './Components'

export const BetInvestment: React.FC<{
  item: BetSlipItem
}> = ({ item }) => {
  if (!item.selection || isFatalErrorType(item.betErrorType)) return null
  if (!isToteSelection(item.selection)) {
    return <FobInvestment item={item} />
  }

  if (isToteSelection(item.selection)) {
    return <ToteInvestment item={item} />
  }

  return null
}
